.product-wrapper {
  display: block;
  padding: var(--spacer);
  width: fit-content;
  border-radius: 4px;
  min-width: calc(17 * var(--spacer));
  min-height: calc(7 * var(--spacer));
  cursor: default;
  color: var(--main-titles-inputs-600);

  .description-txt {
    width: auto;
    padding-right: var(--spacer);
    font-family: var(--font-family-secondary);
  }
}

.max-content {
  width: max-content;
}

gz-tooltip {
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-large);
  width: 100%;
}
